import { HttpErrorResponse, HttpHandlerFn, HttpRequest, HttpContextToken } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { AuthService } from "../services/auth/auth.service";

export const BYPASS_ERROR = new HttpContextToken<boolean>(() => false);

export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {

  if (req.context.get(BYPASS_ERROR)) {
    return next(req);
  }

  const _authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        _authService.logout();
      } else if (error.status === 500) {
        console.log("Hubo un error en el servidor");
      } 
      return throwError(() => error);
    })
  );
}